import { createContext } from 'react';

/**
 * Present only where a section should collapse (the Details tab). Where it is
 * absent, the same section component renders as a plain, always-open card.
 */
export interface SectionAccordionState {
  /** Base for the header/region ids that aria-controls ties together. */
  idBase: string;
  isExpanded: boolean;
  onToggle: () => void;
  /** Called once the section has finished expanding, so a jump can scroll to its final layout. */
  onExpanded?: () => void;
}

export const SectionAccordionContext = createContext<SectionAccordionState | null>(null);
